import './instrument';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';

import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import useUserStore from './hooks/useUserStore';
// Hooks
// import useAuth from './hooks/useAuth';
// import useSessionVerify from './hooks/userSessionVerify';

// Components
import Navbar from '@/common/Navbar';
// import Login from './components/login/Login';
// import Register from './components/register/Register';
// import Profile from './components/profile/Profile';

import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import Home from '@/components/Home';
import Login from '@/components/Login';
import Series from '@/components/Series';
import Serie from '@/components/Serie';
import Register from '@/components/Register';
import Episode from '@/components/Episode/Episode';
import Recommendations from '@/components/Recommendations/Recomendations';
import Movies from '@/components/Movies';
import Movie from '@/components/Movie';
import Administration from '@/components/Administration/Administration';
import Dashboard from '@/components/Administration/Dashboard/Dashboard';
import NoAccess from '@/components/NoAccess';
import Reglas from '@/components/Reglas/Reglas';
import ResetPassword from '@/components/ResetPassword/ResetPassword';
import Donaciones from '@/components/Donaciones/Donaciones';
import Profile from '@/components/Profile/Profile';
import Users from '@/components/Administration/Users/Users';
import User from '@/components/Administration/User';
import AdminSeries from '@/components/Administration/AdminSeries/AdminSeries';
import AdminSerie from '@/components/Administration/AdminSeries/AdminSerie';
import Videos from '@/components/Administration/Videos/Videos';
import CreateSerie from '@/components/Administration/AdminSeries/CreateSerie/CreateSerie';
import AdminMovies from '@/components/Administration/AdminMovies';
import AdminMovie from '@/components/Administration/AdminMovies/AdminMovie';
import CreateMovie from '@/components/Administration/AdminMovies/CreateMovie/CreateMovie';
import Emails from '@/components/Administration/Emails/Emails';
import ContactLists from '@/components/Administration/Emails/ContactLists/ContactLists';
import ContactList from '@/components/Administration/Emails/ContactLists/ContactList/ContactList';
import Campaigns from '@/components/Administration/Emails/Campaigns/Campaigns';
import CampaignForm from '@/components/Administration/Emails/Campaigns/CampaignForm/CampaignForm';
import AdminGenres from '@/components/Administration/AdminGenres/AdminGenres';
import AdminGenre from '@/components/Administration/AdminGenres/AdminGenre/AdminGenre';
import CreateGenre from '@/components/Administration/AdminGenres/CreateGenre/CreateGenre';

// dotenv.config();

const Redirect = ({ children, reverse, role }) => {
  const navigate = useNavigate();
  const isLoggedIn = useUserStore((state) => state.isLoggedIn);
  const user = useUserStore((state) => state.user);

  const roles = {
    admin: ['admin'],
    donor: ['donor', 'admin'],
    user: ['donor', 'admin', 'user'],
  };

  const to = reverse ? '/' : '/login';
  useEffect(() => {
    if (!isLoggedIn) {
      navigate(to);
    }
  }, [isLoggedIn]);

  // For admin routes, enforce the role check synchronously.
  // For donor/user routes, let the request through — the API 403 handles access control
  // so users don't see a stale NoAccess screen after their role changes.
  if (role === 'admin' && !roles.admin.includes(user?.role)) {
    return <NoAccess />;
  }

  return <>{children}</>;
};

const HomeChanger = () => {
  const isLoggedIn = useUserStore((state) => state.isLoggedIn);
  if (isLoggedIn) {
    return <Recommendations />;
  } else {
    return <Home />;
  }
};

const RoutesList = [
  {
    path: '/',
    element: <HomeChanger />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/reglas',
    element: <Reglas />,
  },
  {
    path: '/donaciones',
    element: <Donaciones />,
  },
  {
    path: '/perfil',
    element: (
      <Redirect>
        <Profile />
      </Redirect>
    ),
  },
  {
    path: '/crear-cuenta',
    element: <Register />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/series',
    element: (
      <Redirect role='donor'>
        <Series />
      </Redirect>
    ),
  },
  {
    path: '/series/:serie',
    element: (
      <Redirect role='donor'>
        <Serie />
      </Redirect>
    ),
  },
  {
    path: '/series/:serie/:episode',
    element: (
      <Redirect role='donor'>
        <Episode />
      </Redirect>
    ),
  },
  {
    path: '/peliculas/',
    element: (
      <Redirect role='donor'>
        <Movies />
      </Redirect>
    ),
  },
  {
    path: '/peliculas/:movie',
    element: (
      <Redirect role='donor'>
        <Movie />
      </Redirect>
    ),
  },
  {
    path: '/administracion',
    element: (
      <Redirect role='admin'>
        <Administration>
          <Dashboard />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/usuarios',
    element: (
      <Redirect role='admin'>
        <Administration>
          <Users />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/usuarios/:id',
    element: (
      <Redirect role='admin'>
        <Administration>
          <User />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/series',
    element: (
      <Redirect role='admin'>
        <Administration>
          <AdminSeries />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/series/nueva',
    element: (
      <Redirect role='admin'>
        <Administration>
          <CreateSerie />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/series/:id',
    element: (
      <Redirect role='admin'>
        <Administration>
          <AdminSerie />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/peliculas',
    element: (
      <Redirect role='admin'>
        <Administration>
          <AdminMovies />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/peliculas/nueva',
    element: (
      <Redirect role='admin'>
        <Administration>
          <CreateMovie />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/peliculas/:id',
    element: (
      <Redirect role='admin'>
        <Administration>
          <AdminMovie />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/generos',
    element: (
      <Redirect role='admin'>
        <Administration>
          <AdminGenres />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/generos/nuevo',
    element: (
      <Redirect role='admin'>
        <Administration>
          <CreateGenre />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/generos/:id',
    element: (
      <Redirect role='admin'>
        <Administration>
          <AdminGenre />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/videos',
    element: (
      <Redirect role='admin'>
        <Administration>
          <Videos />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/correos',
    element: (
      <Redirect role='admin'>
        <Administration>
          <Emails />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/correos/listas',
    element: (
      <Redirect role='admin'>
        <Administration>
          <ContactLists />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/correos/listas/:id',
    element: (
      <Redirect role='admin'>
        <Administration>
          <ContactList />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/correos/campanas',
    element: (
      <Redirect role='admin'>
        <Administration>
          <Campaigns />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/correos/campanas/nueva',
    element: (
      <Redirect role='admin'>
        <Administration>
          <CampaignForm />
        </Administration>
      </Redirect>
    ),
  },
  {
    path: '/administracion/correos/campanas/:id',
    element: (
      <Redirect role='admin'>
        <Administration>
          <CampaignForm />
        </Administration>
      </Redirect>
    ),
  },
];

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

// Restore Sentry user context from persisted Zustand store on page load
const persistedUser = useUserStore.getState().user;
if (persistedUser) {
  Sentry.setUser({ id: persistedUser._id || persistedUser.id, username: persistedUser.nombre, email: persistedUser.correo });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className='flex flex-col items-center justify-center min-h-screen text-center gap-4 p-4'>
          <h2 className='font-montserrat font-bold text-xl text-gray-800'>Algo salio mal</h2>
          <p className='font-montserrat text-gray-500 text-sm'>Ocurrio un error inesperado. Nuestro equipo ha sido notificado.</p>
          <button
            onClick={() => { resetError(); window.location.href = '/'; }}
            className='px-4 py-2 bg-red-1 text-white rounded-lg font-montserrat text-sm hover:opacity-90'
          >
            Volver al inicio
          </button>
        </div>
      )}
    >
      <Navbar />
      <ToastContainer />
      <SentryRoutes>
        {RoutesList.map((route, index) => {
          return <Route key={index} path={route.path} element={route.element} />;
        })}
      </SentryRoutes>
    </Sentry.ErrorBoundary>
  </BrowserRouter>
);
